

function Footer() {

    return(
        <div className="footer">
                <p>&copy; All rights reserved weekend quiz submission</p>
        </div>
    )
}

export default Footer;